import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { X, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { changelogApi } from '../../api/changelogApi';
import { haptic } from '../../telegram';

// Лёгкое, не блокирующее уведомление об обновлении платформы — по сути «пуш» при
// открытии ТМА. В отличие от согласия с юр. документами (Onboarding), пользователь
// может просто закрыть его — доступ к приложению при этом не ограничивается.
// Показывается только если в @app/shared/changelog у последней записи notify: true,
// пользователь ещё не отмечал её как увиденную (закрытую), и не поставил галочку
// «Больше не показывать» на странице «Что нового».
export function ChangelogAlert() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['changelog'], queryFn: () => changelogApi.getStatus() });
  const [dismissedLocally, setDismissedLocally] = useState(false);
  const seenMutation = useMutation({
    mutationFn: () => changelogApi.markSeen(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['changelog'] }),
  });

  if (!data?.shouldNotify || dismissedLocally) return null;
  const latest = data.entries.find((e) => e.version === data.latestNotifiableVersion) ?? data.entries[0];
  if (!latest) return null;

  const open = () => {
    haptic('light');
    setDismissedLocally(true);
    seenMutation.mutate();
    nav('/settings/changelog');
  };

  const close = () => {
    haptic('light');
    setDismissedLocally(true);
    seenMutation.mutate();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 'calc(env(safe-area-inset-top, 0px) + 10px)',
        left: 12,
        right: 12,
        zIndex: 1000,
        display: 'flex',
        gap: 10,
        alignItems: 'center',
        padding: 14,
        borderRadius: 14,
        border: '1px solid var(--rf-accent, #2e86ff)',
        background: 'var(--rf-surface-solid, #171b26)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
      }}
    >
      <Sparkles size={18} style={{ flexShrink: 0, color: 'var(--rf-accent, #2e86ff)' }} />
      <div
        role="button"
        onClick={open}
        style={{ flex: 1, minWidth: 0, cursor: 'pointer' }}
      >
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 2, color: 'var(--rf-text, #e8ecf4)' }}>
          Мы стали ещё лучше!
        </div>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--rf-accent, #2e86ff)' }}>
          Что нового? →
        </div>
      </div>
      <button
        type="button"
        aria-label="Закрыть"
        onClick={close}
        style={{ background: 'none', border: 'none', padding: 4, cursor: 'pointer', color: 'var(--rf-text-2, #96a0b5)', flexShrink: 0 }}
      >
        <X size={18} />
      </button>
    </div>
  );
}

export default ChangelogAlert;
